import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connectStateResults } from 'react-instantsearch-dom';
import vahoy from '../../../javascript/vahoy';

// InstantSearch keeps a failed search's error to itself: hits stay empty and the "No Results"
// message stays hidden, so without this the page is simply blank. Searches go straight from the
// browser to Algolia, so the Ahoy event is the only server-side record that one failed.
export function SearchErrorMessage({ error }) {
  useEffect(() => {
    if (error) {
      vahoy.track('MediaMatches#searchError', { message: error.message, status: error.status });
    }
  }, [error]);

  if (!error) return null;

  return (
    <div className="text-center p-4 fw-bold">
      We couldn&apos;t load matches for this search. Try a shorter search.
    </div>
  );
}

SearchErrorMessage.propTypes = {
  error: PropTypes.instanceOf(Object),
};

SearchErrorMessage.defaultProps = {
  error: undefined,
};

export default connectStateResults(SearchErrorMessage);
